module.exports = __webpack_public_path__ + "static/media/banner.892c8ab3.png";